import { render } from "./RetailerPage.vue?vue&type=template&id=4e91b2b9&scoped=true"
import script from "./RetailerPage.vue?vue&type=script&lang=js"
export * from "./RetailerPage.vue?vue&type=script&lang=js"

import "./RetailerPage.vue?vue&type=style&index=0&id=4e91b2b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e91b2b9"]])

export default __exports__